import { session, type ScreenId } from './session.svelte';

export function navigateTo(screen: ScreenId | string): void {
  window.location.hash = `/${screen}`;
}

export function goBack(): void {
  const prev = session.goBack();
  if (prev) window.location.hash = `/${prev}`;
}

export function initRouter(): void {
  window.addEventListener('hashchange', handleRoute);
  handleRoute(); // initial route
}

function handleRoute(): void {
  const hash = window.location.hash.replace(/^#\/?/, '') as ScreenId;
  const valid: ScreenId[] = ['vehicle', 'upload', 'ar', 'results', 'video', 'videoresults'];
  const screen: ScreenId = valid.includes(hash) ? hash : 'vehicle';
  // Only push to history on explicit navigation (navigateTo), not on raw hash change
  const current = session.currentScreen;
  if (screen !== current) {
    session.navigate(screen);
  } else {
    session.currentScreen = screen;
  }
}
